module.exports = __webpack_public_path__ + "static/img/11.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/11.png
// module id = He4e
// module chunks = 0